// import { useModal } from '@/feature/ModalFeature'
// import LogApi from '@/core/Session/LogApi'

export function useErrorApi(modalController) {
    const modal = modalController

    function errorApi(err) {
        errorApiShowAlert(err)
        errorApiLog(err)
    }

    function errorApiShowAlert(err) {
        console.log('err', err)
        let alertMsg = '';
        let errorId = err?.id != null ? err?.id : err?.code;

        if (errorId) {
            switch (errorId) {
                case 401:
                    alertMsg = err.message;
                    break;
                case 412:
                    alertMsg = "Token invalid";
                    break;
                default:
                    alertMsg = err.message;
                    break;
            }
        } else {
            alertMsg = "Network connection error!";
        }

        if (modal?.alertModal != null) {
            let id = err?.id
            let code = err?.code
            alertMsg += `<br>(id: ${id}, code: ${code})`
            modal.alertModal
                .clearModal()
                .setMsg(alertMsg)
                .show()
        }
    }

    function errorApiLog() {
        // LogApi.apiSaveErrorLog(err, null, null, null).subscribe({
        //     next: (data) => {
        //         console.log(data)
        //     },
        //     error: (err) => {
        //         console.log(err)
        //     },
        // })
    }

    return {
        errorApi,
        errorApiLog,
        errorApiShowAlert,
    }
}
